module.exports = "<button \n\tclass=\"button compare-button button-block\" \n\tng-class=\"{ 'active': $ctrl.inList($ctrl.product.icecat.id) }\"\n\tng-click=\"$ctrl.add($ctrl.product)\">\n\t<i class=\"fa fa-balance-scale\"></i><span>{{  'compare' | translate | ucfirst }}</span>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./app/components/compareButton/compareButton.html
// module id = 398
// module chunks = 0